import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {SelectModule} from "primeng/select";
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from "@angular/forms";
import {BaseService} from "@6grain/masofa-monolith-api-client/dictionaries/api.base.service";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {ServerTranslateService} from "@services/server-translate.service";
import {DropdownComponent} from "@components/dropdown/dropdown.component";
import {getDeepField, userNames} from "@app/utils/_msf";
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'msf-select',
  exportAs: 'msfSelect',
  imports: [
    SelectModule,
    FormsModule,
    DropdownComponent,
  ],
  templateUrl: './select.html',
  styleUrl: './select.scss',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MsfSelect),
      multi: true
    }
  ],
})
export class MsfSelect implements OnInit, OnDestroy, ControlValueAccessor, OnChanges {
  $destroy$: Subject<void> = new Subject<void>();

  orderedOptions: any[] = [];
  @Input() loading: boolean = false;

  constructor(
    private serverTranslateService: ServerTranslateService,
    private translateService: TranslateService,
  ) {
  }

  private onTouchedCallback: () => void = () => {
  };
  private onChangeCallback: (_: any) => void = () => {
  };


  writeValue(obj: any): void {
    throw new Error("Method not implemented.");
  }

  registerOnChange(fn: any): void {
    throw new Error("Method not implemented.");
  }

  registerOnTouched(fn: any): void {
    throw new Error("Method not implemented.");
  }

  setDisabledState?(isDisabled: boolean): void {
    throw new Error("Method not implemented.");
  }

  @Input() options?: any[] = [];
  @Input({required: true}) model: any;
  @Output() modelChange = new EventEmitter<any>();
  @Output() selectItem = new EventEmitter<any>();
  @Input() placeholder?: string = 'Выберите...';
  @Input() optionLabel: string = 'label';
  @Input() optionSubtitle?: string;
  @Input() optionSubtitleJoiner?: string;
  @Input() translateBy: string | null = 'names';
  @Input() optionValue?: string = 'id';
  @Input() service?: BaseService | any;
  @Input() serviceMethod?: BaseService | any;
  @Input() showClear = false
  @Input() filter = {};
  @Input() width = '100%';
  @Input() isUser = false;
  @Input() externalLoading?: boolean | (() => boolean); // Внешнее состояние загрузки


  ngOnInit() {
    // Проверяем внешнее состояние загрузки
    if (this.externalLoading !== undefined) {
      const loadingValue = typeof this.externalLoading === 'function'
        ? this.externalLoading()
        : this.externalLoading;
      this.loading = loadingValue;
    }

    if (this.service && this.serviceMethod) {
      this.loading = true;
      this.service[this.serviceMethod](this.filter || {})
        .pipe(takeUntil(this.$destroy$))
        .subscribe((data: any) => {
          this.options = data;
          this.orderedOptions = this.translatedOptions();
          this.loading = false;
        });
    }

    this.translateService
      .onLangChange
      .pipe(takeUntil(this.$destroy$))
      .subscribe(lang => {
        this.orderedOptions = this.translatedOptions();
      })
  }

  ngOnDestroy() {
    this.$destroy$.next();
    this.$destroy$.complete();
  }

  translatedOptions(): any[] {
    if (!this.options || !Array.isArray(this.options)) {
      return [];
    }


    return this.options
      .map((item: any) => {
        let labelValue: any;
        if (this.translateBy && this.translateBy === 'locale') {
          labelValue = this.translateService.instant(item[this.optionLabel])
        } else if (this.translateBy && this.translateBy !== 'none') {
          labelValue = this.serverTranslateService.translate(item, this.translateBy);
        } else {
          labelValue = getDeepField(item, this.optionLabel);
        }
        if (this.isUser) {
          labelValue = userNames(item)
        }
        item["label"] = this.serverTranslateService.formatTranslationLabel(labelValue);
        if (this.optionSubtitle) {
          const subtitleValue = getDeepField(item, this.optionSubtitle);
          item['subtitle'] = this.serverTranslateService.formatTranslationLabel(subtitleValue);
        }
        return item;
      })
      .filter((item: any) => {
        const hasValidLabel = this.serverTranslateService.isValidDisplayLabel(item.label);
        const namesNull = this.translateBy === 'names' && item.names
          && this.serverTranslateService.isEmptyTranslationValue(item.names);
        return hasValidLabel && !namesNull;
      })
      // .slice()
      .sort((a, b) => {
        const labelA = a?.label?.toString()?.toLowerCase();
        const labelB = b?.label?.toString()?.toLowerCase();
        return labelA.localeCompare(labelB);
      })

  }
  onSelectItem() {
    const item = this.options?.find(i => getDeepField(i, this.optionValue as string) === this.model);
    this.selectItem.emit(item);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options'] || changes['optionSubtitle'] || changes['optionSubtitleJoiner']) {
      this.orderedOptions = this.translatedOptions();
    }

    // Обновляем loading при изменении externalLoading
    if (changes['externalLoading']) {
      if (this.externalLoading !== undefined) {
        const loadingValue = typeof this.externalLoading === 'function'
          ? this.externalLoading()
          : this.externalLoading;
        this.loading = loadingValue;
      }
    }
  }
}
